import React from 'react';
import { CreatePageLayout } from 'framework/ui/layout';
import { CreateForm } from 'framework/form';
import { useNavigate } from 'react-router-dom';

import { useProjectId } from 'domain/shared/project';
import { useNewProjectUrl } from 'domain/shared/newProject';
import useClientPortalService from '../../useClientPortalService';
import ClientPortalTaskForm from './ClientPortalTaskForm';
import ClientPortalTaskFormButtons from './ClientPortalTaskFormButtons';
import { useClientPortal } from '../../useClientPortal';
import { getClientPortalVisibleUsers, mapClientPortalTaskPayload } from '../../mockData';

const CreateClientPortalTaskLayout = () => {
  const { getCreatePortalTaskValidation, createClientPortalTask } = useClientPortalService();
  const id = useProjectId();
  const { getProjectClientPortalUrl } = useNewProjectUrl();
  const navigate = useNavigate();
  const { data: clientPortalData } = useClientPortal(id);
  const clients = getClientPortalVisibleUsers(clientPortalData?.clientPortal?.users || []);

  return (
    <CreateForm
      submitFormFunc={async formData => {
        return createClientPortalTask(id, mapClientPortalTaskPayload(formData));
      }}
      afterSubmit={{
        redirect: getProjectClientPortalUrl(id),
        message: 'You are awesome! Client Task has been successfully created.',
      }}
      getDataFunc={() => Promise.resolve()}
      getValidationSchemaFunc={getCreatePortalTaskValidation}
    >
      <CreatePageLayout
        isCancelButtonVisible={false}
        title="Create Task For Client:"
        buttons={<ClientPortalTaskFormButtons onCancelAction={() => navigate(getProjectClientPortalUrl(id))} />}
      >
        <ClientPortalTaskForm clients={clients} />
      </CreatePageLayout>
    </CreateForm>
  );
};

export default CreateClientPortalTaskLayout;
